export const MY_APPOINTMENTS_PAGE_TITLE = "My Appointments";
